import React from 'react';
import _ from "underscore";

import RetinaImage from "react-retina-image"
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import config from '../../config';
import DesignerMenuItem from "./common/DesignerMenuItem";

const ItemsMenuReversedColumns = (
    {
        menu_item,
        collections, collections_prefix,
        extra, extra_prefix, designers, show_designers_menu
    }
) => {
    const has_extra_values = extra.length > 0;
    const extra_separator = has_extra_values && Math.ceil((extra.length + 1) / 2);
    const extra_left = has_extra_values && extra.slice(0, extra_separator);
    const extra_right = has_extra_values && extra.slice(extra_separator);
    const designers_list = menu_item.manual_designers_list || designers;
    let left_collections = 0, right_collections = 0;
    if(collections && collections.values && collections.values.length > 0){
        const collections_count = collections.values.length;
        if(collections_count % 2 > 0){
            left_collections = Math.ceil(collections_count / 2);
            right_collections = (left_collections - 1) * -1;
        } else {
            left_collections = Math.ceil(collections_count / 2) + 1;
            right_collections = (left_collections - 2) * -1;
        }
    }

    return (
        <div className="top-nav">
            <Container>
                <Row>
                    {designers_list && designers_list.length > 0 &&
                    <Col xl={{ span: 2, offset: 1 }} lg={{ span: 3, offset: 0 }}>
                        <h4 className="top-nav__nav-title">{menu_item.collections_info.title}</h4>
                            <Nav className="top-nav__nav-list">
                                {_.map(designers_list, (designer, idx) => {
                                    return (
                                        <DesignerMenuItem
                                            key={designer.id || idx}
                                            url={menu_item.href}
                                            menu_item={menu_item}
                                            designer={designer}
                                            show_designers_menu={show_designers_menu}
                                            classname="top-nav__nav-list-item-primary"
                                        />
                                    )
                                })}
                            </Nav>
                    </Col>
                    }
                    {collections && collections.values.length > 0 &&
                        <Col lg={4}>
                            <h4 className="top-nav__nav-title">{menu_item.title} Type</h4>
                            <Row>
                                <Col lg={6}>
                                    <Nav className="top-nav__nav-list">
                                        {_.map(collections.values.slice(0, left_collections), (collection, idx) => {
                                            const collectionEncoded = encodeURIComponent(collection.label ? collection.label : collection.key);
                                            return (
                                                <Nav.Item
                                                    key={idx}
                                                    className="top-nav__nav-list-item-secondary nav-link nav-top-link"
                                                    as="a"
                                                    href={`${collection.handle ? config.host_rebag_shop + "/collections/" + collection.handle : menu_item.href + "&" + menu_item.collections_filter_key + "=" + collectionEncoded}`}
                                                >
                                                    {collection.label ? collection.label : collection.key.replace(collections_prefix, "")}
                                                </Nav.Item>
                                            );
                                        })}
                                    </Nav>
                                </Col>
                                <Col lg={6}>
                                    <Nav className="top-nav__nav-list">
                                        {_.map(collections.values.slice(right_collections), (collection, idx) => {
                                            const collectionEncoded = encodeURIComponent(collection.label ? collection.label : collection.key);
                                            return (
                                                <Nav.Item
                                                    key={idx}
                                                    className="top-nav__nav-list-item-secondary nav-link nav-top-link"
                                                    as="a"
                                                    href={`${collection.handle ? config.host_rebag_shop + "/collections/" + collection.handle : menu_item.href + "&" + menu_item.collections_filter_key + "=" + collectionEncoded}`}
                                                >
                                                    {collection.label ? collection.label : collection.key.replace(collections_prefix, "")}
                                                </Nav.Item>
                                            );
                                        })}
                                        <Nav.Link
                                            className="top-nav__nav-list-item-secondary nav-top-link"
                                            href={menu_item.href + menu_item.sort}
                                        >
                                            All {menu_item.title} Types
                                        </Nav.Link>
                                    </Nav>
                                </Col>
                            </Row>
                        </Col>
                    }
                    {has_extra_values && !menu_item.collections_info &&
                        <Col lg={4}>
                            <h4 className="top-nav__nav-title">{extra.label}</h4>
                            <Row>
                                <Col lg={6}>
                                    <Nav className="top-nav__nav-list">
                                        {_.map(extra_left, (extra, idx) => {
                                            return <ExtraLink
                                                key={idx}
                                                extra={extra}
                                                prefix={extra_prefix}
                                                menu_item={menu_item}
                                            />;
                                        })}
                                    </Nav>
                                </Col>
                                <Col lg={6}>
                                    <Nav className="top-nav__nav-list">
                                        {_.map(extra_right, (extra, idx) => {
                                            return <ExtraLink
                                                key={idx}
                                                extra={extra}
                                                prefix={extra_prefix}
                                                menu_item={menu_item}
                                            />;
                                        })}
                                        <Nav.Item
                                            className="top-nav__nav-list-item-secondary nav-top-link nav-link"
                                            as="a"
                                            href={menu_item.href + menu_item.sort}
                                        >
                                            All {menu_item.title}
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                            </Row>
                        </Col>
                    }
                    <Col xl={4} lg={5}>
                        <a
                            href={menu_item.img_url}
                            className="top-nav__promo-image-link"
                        >
                            {menu_item && menu_item.img &&
                            <RetinaImage
                                alt={`All ${menu_item.title}`}
                                title={`All ${menu_item.title}`}
                                className="top-nav__promo-image"
                                src={menu_item.img}
                            />
                            }
                        </a>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

const ExtraLink = ({menu_item, extra, prefix}) => {
    return (
        <Nav.Item
            className="top-nav__nav-list-item-secondary nav-link nav-top-link"
            as="a"
            href={`${menu_item.href}&sort=created-descending&${menu_item.extra_filter_key}=${encodeURIComponent(extra.key)}`}
        >
            {extra.key.replace(prefix, "")}
        </Nav.Item>
    );
}

export default ItemsMenuReversedColumns;